module.exports = __webpack_public_path__ + "1951d6c16328070c397d5ed01c14b6e5.png";